import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React from 'react';
import { AdvancedSearchInput } from '../shared/AdvancedSearchInput.jsx';
import { combineLatest } from 'rxjs';
import { AdvancedSearchTemplate } from '../shared/AdvancedSearchTemplate.jsx';
import { AdvancedSearchKey } from '../shared/_enums';

export default class AdvancedSearchPopup extends ReactBrick {
    init($) {
        // as this is an OR filtering, clear the selected values of the other filter
        // this logic is defined in init to avoid being run multiple times (if it would be in render())
        $.observe('Selected Approvers', true).subscribe((list) => {
            if (list !== null && list.length > 0) {
                $.trigger('Clear Cost Centers');
                $.trigger('Clear PrnByNumber');
                $.trigger('Clear PrnByWBS');
                $.trigger('Clear PrnByInternal');
            }
        });
        combineLatest([
            $.observe('Selected Cost Centers', true),
            $.observe('Selected PrnByNumber', true),
            $.observe('Selected PrnByInternal', true),
            $.observe('Selected PrnByWBS', true),
        ]).subscribe(([list1, list2, list3, list4]) => {
            if (
                (list1 !== null && list1.length > 0) ||
                (list2 !== null && list2.length > 0) ||
                (list3 !== null && list3.length > 0) ||
                (list4 !== null && list4.length > 0)
            ) {
                $.trigger('Clear Approvers');
            }
        });
        $.set('Selected Approvers', []);
        $.set('Selected Cost Centers', []);
        $.set('Selected PrnByNumber', []);
        $.set('Selected PrnByInternal', []);
        $.set('Selected PrnByWBS', []);
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {Element}
     */

    static getReactComponent($) {
        return (props) => {
            const hidden = useProperty($, 'Hidden');
            const approvers = useProperty($, 'Approvers');
            const selectedApprovers = useProperty($, 'Selected Approvers');
            const costCenters = useProperty($, 'Cost Centers');
            const selectedCostCenters = useProperty($, 'Selected Cost Centers');
            const prnByNumber = useProperty($, 'PrnByNumber');
            const selectedPrnByNumber = useProperty($, 'Selected PrnByNumber');
            const prnByWbs = useProperty($, 'PrnByWBS');
            const selectedPrnByWbs = useProperty($, 'Selected PrnByWBS');
            const prnByInternal = useProperty($, 'PrnByInternal');
            const selectedPrnByInternal = useProperty($, 'Selected PrnByInternal');
            const isFullScreen = useProperty($, 'Is Full Screen');
            const image = useProperty($, 'Image');
            const cannotApply =
                (selectedApprovers === undefined || selectedApprovers.length === 0) &&
                (selectedCostCenters === undefined || selectedCostCenters.length === 0) &&
                (selectedPrnByNumber === undefined || selectedPrnByNumber.length === 0) &&
                (selectedPrnByWbs === undefined || selectedPrnByWbs.length === 0) &&
                (selectedPrnByInternal === undefined || selectedPrnByInternal.length === 0);

            const handleClose = () => {
                $.trigger('Apply Mass Change Advanced Search');
                $.set('Hidden', true);
            };

            const handleClear = () => {
                $.trigger('Clear Approvers');
                $.trigger('Clear Cost Centers');
                $.trigger('Clear PrnByNumber');
                $.trigger('Clear PrnByInternal');
                $.trigger('Clear PrnByWBS');
            };

            const searchFields = (
                <>
                    <AdvancedSearchInput context={$} data={approvers} searchKey={AdvancedSearchKey.APPROVER} />
                    <AdvancedSearchInput context={$} data={costCenters} searchKey={AdvancedSearchKey.COST_CENTER} />
                    <AdvancedSearchInput
                        context={$}
                        data={prnByNumber}
                        searchKey={AdvancedSearchKey.PRN_BY_NUMBER}
                        title="Person Responsible ID (PRN)"
                    />
                    <AdvancedSearchInput
                        context={$}
                        data={prnByInternal}
                        searchKey={AdvancedSearchKey.PRN_BY_INTERNAL}
                        title="Internal WBS (for specific markets in AMS and LATAM)"
                        placeholderText="Search By ID"
                    />
                    <AdvancedSearchInput
                        context={$}
                        data={prnByWbs}
                        searchKey={AdvancedSearchKey.PRN_BY_WBS_ELEMENT}
                        title="WBS Elements"
                        placeholderText="Search By ID"
                    />
                </>
            );

            return (
                !hidden && (
                    <AdvancedSearchTemplate
                        image={image}
                        searchFields={searchFields}
                        isFullScreen={isFullScreen}
                        cannotApply={cannotApply}
                        handleClose={handleClose}
                        handleClear={handleClear}
                    />
                )
            );
        };
    }
}

registerBrick('0181f239d5b036125a67', AdvancedSearchPopup);
